import { createSelector } from '@reduxjs/toolkit';

import { hotelsListSelector } from '../store/hotels/selectors';

export const getHotelsIds = createSelector(hotelsListSelector, (hotels) =>
  hotels.map((hotelItem) => hotelItem.id),
);

export const getHotelsSurchargesByLevel = createSelector(
  hotelsListSelector,
  (hotels) =>
    hotels.map((hotelItem) => hotelItem.analyticsInfo.surchargesByLevel),
);

export const getHotelsAccommodationAvailability = createSelector(
  hotelsListSelector,
  (hotels) => hotels.map((hotel) => hotel.availability.hotel),
);

export const getHotelsFlightSeats = createSelector(
  hotelsListSelector,
  (hotels) => hotels.map((hotel) => hotel.availability.flight),
);

export const getHotelsTourIds = createSelector(hotelsListSelector, (hotels) =>
  hotels.map((hotel) => hotel.tourId),
);

export const bundleIdsSelector = createSelector(hotelsListSelector, (hotels) =>
  hotels.map((hotel) => hotel.analyticsInfo.bundleId),
);

export const acmComponentIdsSelector = createSelector(
  hotelsListSelector,
  (hotels) => hotels.map((hotel) => hotel.analyticsInfo.acmComponentId),
);
